'use client'

import dynamic from 'next/dynamic'
import { useCouponTrigger } from '@/lib/hooks/useCouponTrigger'
import type { CouponExamOption } from './types'

const CouponBar = dynamic(
  () => import('./CouponBar').then((m) => ({ default: m.CouponBar })),
  { ssr: false }
)

interface CouponBarMountProps {
  examOptions: CouponExamOption[]
  prefillSlug?: string
}

export function CouponBarMount({
  examOptions,
  prefillSlug,
}: CouponBarMountProps) {
  const { armed, dismiss, markClaimed } = useCouponTrigger(true)

  if (!armed) return null

  const prefill =
    prefillSlug && examOptions.some((o) => o.slug === prefillSlug)
      ? prefillSlug
      : null

  return (
    <CouponBar
      examOptions={examOptions}
      prefillSlug={prefill}
      onDismiss={dismiss}
      onClaim={markClaimed}
    />
  )
}
